module.exports = __webpack_public_path__ + "static/favicon-204499a60bc3dc2ec06f315a7f458625.ico";